import React from "react";

const PolicyEffectText = () => {

  return (
    <div className="text-left">
      <p className="font-md text-gray-400 ">This policy is effective as of June 1, 2022</p>
    </div>
  )
}

export default PolicyEffectText;
